import {Component, OnInit, Inject} from 'ng-metadata/core';
import {BrowseSearchService} from './browseSearch.service';
import {SearchService} from "../search.service";
import {BrowseSearchBarService} from "./browseSearchBar/browseSearchBar.service";


import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {getAttributesMap, getVid} from "../../appConfig/appConfigForward";
import {PagesTitlesService} from "../../infra/accessibility/pagesTitles.service";
import {SearchFieldsService} from "../search.fields.service";
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";

const get = require('lodash/get');
const orderBy = require('lodash/orderBy');

@Component({
    selector: 'prm-browse-search',
    templateUrl: 'components/search/browse/browse-search.html',
})

export class PrmBrowseSearch implements OnInit {

    public pagingConfiguration = {
        firstPage: false,
        paging: false
    };
    private _showPrevButtonPredicate;
    private _showNextButtonPredicate;

    constructor(private browseSearchService: BrowseSearchService,
                private searchService: SearchService,
                private browseSearchBarService: BrowseSearchBarService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private pagesTitlesService: PagesTitlesService,
                private searchFieldsService: SearchFieldsService,
                private configurationUtil: ConfigurationUtil) {
        this.browseSearchService.resetParams();

        this._showPrevButtonPredicate = () => {
            return this.browseSearchService.backTerm == undefined ? false : true;
        };

        this._showNextButtonPredicate = () => {
            return this.browseSearchService.nextTerm == undefined ? false : true;
        };

        this.updatePagesTitles();
    }

    ngOnInit() {

        this.browseSearchBarService.searchBarInput = this.$state.params['browseQuery']; //init the search bar text
        this.getData();
    }


    get selectedScope(): Object {
        return this.browseSearchBarService.selectedScope;
    }

    set selectedScope(newScope: Object) {
        this.browseSearchBarService.selectedScope = newScope;
    }

    private updatePagesTitles() {
        let searchQuery = this.$state.params['browseQuery'];
        let actionToCode = {
            'exploreMain.browseSearch': !this.isSuprima() ? ['nui.mainmenu.label.browse', '$$QUERY$$'] : ['mainmenu.label.BrowseSearch', '$$QUERY$$'],
        };

        let titles = {codes: actionToCode[this.$state.current.name], query: searchQuery};
        this.pagesTitlesService.updatePagesTitles(titles);
    }

    public isSuprima() {
        return this.configurationUtil.isSuprima();
    }

    public getData() {

        if (this.browseSearchBarService.scopes != undefined) {
            this.selectedScope = this.browseSearchBarService.scopes[0];
            this.deepLinkPref()
        } else {
            this.browseSearchBarService.scopesProgress = true;
            let promise = this.browseSearchBarService.getLinkScopes();
            // let self = this;
            promise.then((response) => {
                this.browseSearchBarService.scopesProgress = false;
                this.browseSearchBarService.scopes = orderBy(response.data, function (obj) {
                    return parseInt(obj.SourceCode5, 10)
                });
                this.selectedScope = this.browseSearchBarService.scopes[0];
                this.browseSearchBarService.setSlectedScope();
                this.deepLinkPref()


            },);

        }
    }


    // @beacon({'p':'brief', 'op': 'CitationsLink'})
    public deepLinkPref() {

        let selectedScope = this.$state.params['browseScope'];
        let query = this.$state.params['browseFirstTerm'] || this.$state.params['browseQuery'];
        let innerPnxIndex = this.$state.params['innerPnxIndex'];
        let numOfUsedTerms = this.$state.params['numOfUsedTerms'];
        let fn = this.$state.params['fn'];
        let offset = (fn === 'BrowseNext' || fn ==='BrowseBack') ?this.$state.params['offset']:0;
        if (selectedScope != null) this.doQuery(fn, query, selectedScope, innerPnxIndex, numOfUsedTerms,offset);
    }


    //@beacon({'p':'search', 'op': 'browse'})
    private doQuery(fn: any, query: any, selectedScope: any, innerPnxIndex: any, numOfUsedTerms: any, offset:any) {
        {
            if (this.$state.params['query'] != undefined) {
                return;
            }
            this.browseSearchService.getSearchJson(fn, query, selectedScope, -1, innerPnxIndex, numOfUsedTerms,false, offset);
            for (let tempScope of this.browseSearchBarService.scopes) {
                if (tempScope['SourceCode1'] === selectedScope) {
                    this.browseSearchBarService.selectedScope = tempScope
                    break;
                }
            }
        }
    }


    get inProgress(): boolean {
        return this.browseSearchService.inProgress;
    }

    public showList(): boolean {
        if (this.browseSearchService.inProgress) {
            return false;
        }
        if (this.browseResult.length > 0) {
            return true;
        }
        return false;
    }

    get browseResult() {
        return this.browseSearchService.browseResult;
    }

    public doNext() {
        let parm = this.nextParam;

        //this.browseSearchService.getSearchJson(parm['fn'], parm['browseFirstTerm'], parm['browseScope'], -1, parm['innerPnxIndex'], parm['numOfUsedTerms']);
        this.$state.go(STATE_NAMES.BROWSE_SEARCH, parm, {reload: false});

    }

    public get nextParam() {
        let scope: string = this.browseSearchService.searchedScope;
        let searchWord: string = this.$state.params['browseQuery'];
        let firstTerm: string = this.browseSearchService.nextTerm;
        let innerPnxIndex = this.browseSearchService.lastPnxIndex;
        let numOfUsedTerms = this.browseSearchService.numOfUsedTerm;
        let offset = this.browseSearchService.offset;
        let fn = "BrowseNext";
        let param: Object = {
            vid: getVid(), browseScope: scope, browseQuery: searchWord, browseFirstTerm: firstTerm,
            numOfUsedTerms: numOfUsedTerms, innerPnxIndex: innerPnxIndex, fn: fn, offset:offset
        };
        return param;

    }

    public get prevParam() {
        let scope: string = this.browseSearchService.searchedScope;
        let searchWord: string = this.$state.params['browseQuery']
        let firstTerm: string = this.browseSearchService.backTerm;
        let innerPnxIndex = this.$state.params['innerPnxIndex'];//this.browseSearchService.lastPnxIndex;
        let numOfUsedTerms = this.browseSearchService.numOfUsedTerm;
        let offset = 0;
        let fn = "BrowseBack";
        if (this.$state.params['offset'] > 0){
            offset = this.$state.params['offset']-1
            fn = "BrowseNext";
        }
        // let param:Object = {vid:getVid(), browseScope:scope,browseQuery:searchWord, browseFirstTerm:firstTerm,
        //     numOfUsedTerms: numOfUsedTerms, innerPnxIndex: innerPnxIndex, fn: fn};
        let param: Object = {
            vid: getVid(),
            browseScope: scope,
            browseQuery: searchWord,
            browseFirstTerm: firstTerm,
            fn: fn,
            numOfUsedTerms: numOfUsedTerms,
            offset: offset
        };
        return param;

    }

    public get searchState() {
        return STATE_NAMES.BROWSE_SEARCH;
    }


    public doPrev() {
        let parm = this.prevParam;
        //this.browseSearchService.getSearchJson(parm['fn'], parm['browseFirstTerm'], parm['browseScope']);
        this.$state.go(STATE_NAMES.BROWSE_SEARCH, parm, {reload: false});

    }

    get showNextButtonPredicate() {
        return this._showNextButtonPredicate;
    }

    get showPrevButtonPredicate() {
        return this._showPrevButtonPredicate;
    }

    get facetToLeft() {
        let viewConfig = getAttributesMap();
        return viewConfig['selectedFacetLocation'] === 'left';
    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/browse/browseSearch.directive.ts